module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v(_vm._s(_vm.groupName))]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v(_vm._s(_vm.title))])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("\n    本模块为后台本地维护，不与钉钉同步；新增/修改仅落本地库。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "员工/标题"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": '暂无' + _vm.title + '记录'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": (_vm.form.id ? '编辑' : '新增') + _vm.title
    },
    on: {
      "on-ok": _vm.save
    },
    model: {
      value: (_vm.showForm),
      callback: function($$v) {
        _vm.showForm = $$v
      },
      expression: "showForm"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CANCEL"
    }
  }, [_vm._v("已取消")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b230615","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrLocalList.vue
// module id = 1800
// module chunks = 8